<template>
  <div class="card-deck mb-3">
    <div style="color: gray; margin-bottom: 15px" v-if="products.length == 0"><b>No se encontraron productos</b></div>
    <div style="color: gray; margin-bottom: 15px" v-else-if="products.length == 1"><b>1 resultado</b></div>
    <div style="color: gray; margin-bottom: 15px" v-else><b>{{ products.length }} resultados</b></div>
    <div v-for="product in products" :key="product.id">
      <product
        :product="product"
        @click.native="goToProductDetail(product.id)"
      ></product>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Product from "../components/Product.vue";


export default {
  components: { Product },
  name: "product-list",
  computed: mapState(["products"]),
  mounted() {
    this.getShopInfo(this.$route.params.id)
    this.getProducts();
  },
  methods: {
    getShopInfo(code) {
      this.$store.state.isLoading = true;
      this.$store.dispatch("GET_SHOP_INFO", code).then(() => {
        this.$store.state.isLoading = false;
      });
    },
    getProducts() {
      this.$store.state.isLoading = true;
      this.$store.dispatch("GET_ALL_PRODUCTS").then(() => {
        this.$store.state.isLoading = false;
      });
    },
    goToProductDetail(productId) {
      this.$router.push({
        path: `product-detail/${productId}`,
      });
    },
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped></style>
